import { SkeletonLoading } from "react-migration/components/SkeletonLoading";
import { Icon } from "react-migration/components/Icon";
import { SectionWithHeaderTooltip } from "../common/SectionWithHeaderTooltip";
import { travelTimeDisplay } from "./travelTimeDisplay";

interface LocalServicesSectionProps {
  tableData: { label: string; timesMinutes: (number | null)[] }[] | null;
  loading: boolean;
}

export function LocalServicesSection({ tableData, loading }: LocalServicesSectionProps) {
  return (
    <SectionWithHeaderTooltip
      title="Proximity to local services"
      tooltipText="Times are based on local area averages (LSOA level) and reflect typical access within the surrounding neighbourhood, not site-specific estimates."
    >
      <div>
        {loading ? (
          <div className="relative p-2 h-[317px]">
            <SkeletonLoading cols={1} rows={6} showPadding={false} bgClassName="bg-transparent" />
          </div>
        ) : (
          tableData && (
            <table className="flex flex-col pointer-events-none gap-y-2 md:-mt-8">
              <thead>
                <tr className="flex px-3">
                  <th className="text-left grow">
                    <span className="invisible">Service</span>
                  </th>
                  <th className="text-center basis-[66px] grow-0 shrink-0 self-end pointer-events-auto">
                    <Icon
                      icon="icon-lt-walk-line"
                      extraClasses="text-icon-base-secondary"
                      title="by walking"
                      size="lg"
                    />
                  </th>
                  <th className="text-center basis-[66px] grow-0 shrink-0 self-end pointer-events-auto">
                    <Icon
                      icon="icon-lt-riding-line"
                      extraClasses="text-icon-base-secondary"
                      title="by bike"
                      size="lg"
                    />
                  </th>
                  <th className="text-center basis-[66px] grow-0 shrink-0 self-end pointer-events-auto">
                    <Icon
                      icon="icon-lt-train-line"
                      extraClasses="text-icon-base-secondary"
                      title="by public transport"
                      size="lg"
                    />
                  </th>
                </tr>
              </thead>
              <tbody className="flex flex-col gap-y-2">
                {tableData.map(({ label, timesMinutes }) => (
                  <tr key={label} className="flex items-center p-3 border gap-y-2 rounded-xl border-blue-grey-200">
                    <td className="text-xs font-normal text-left truncate grow text-text-base-primary">{label}</td>
                    {timesMinutes.map((time, i) => (
                      <td
                        key={i}
                        className="text-center basis-[66px] grow-0 shrink-0 self-end text-sm font-medium text-text-accent-blue"
                      >
                        {travelTimeDisplay(time)}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          )
        )}
      </div>
    </SectionWithHeaderTooltip>
  );
}
